<div style="display: flex; width: 100%; align-items: stretch;" (click)="openDialog();" [formGroup]="formItemDropdownGroup">
    <p-select
      class="w-full dropdown-flat-right"
      [pTooltip]="items.length> 0 ? items[0].description : ''"
      [fitContent]="true"
      [ngClass]="className"
      emptyMessage="No hay registros"
      placeholder="Seleccione opción"
      [options]="items"
      formControlName="itemFormControl"
      optionLabel="description"
      [style]="{'width':'100%', 'height':'2.1rem'}"
      optionValue="code"
      [showClear]="true"
      [readonly]="true"
      (click)="stopPropagation($event)"
      dropdownIcon="none"
      (onClear)="clearItems();">
    </p-select>
    <button 
      pButton
      type="button"
      pRipple
      [disabled]="disabledPropControl"
      style="height: 2.1rem !important; border-top-left-radius: 0; border-bottom-left-radius: 0;"
      [style]="{'border-end-start-radius':'0px', 'border-start-start-radius':'0px'}"
      class="p-button-info p-button-sm btn-small-icon flex align-items-center justify-content-center w-3rem btn-dropdown"
    >
      <span class="p-button-label flex">
          <i class='pi pi-search'></i>
      </span>
    </button>
</div>



